import { StatusForCompanyEnum } from 'api/enums'
import { useMemo, useState } from 'react'
import { CompanyPositionTemplateBlock } from './CompanyPositionTemplateBlock'
import { Feedback } from './Feedback'
import { FillRate } from './FillRate'
import { NewWorker } from './NewWorker'
import { BlockModalType } from './types'
import { WorkerInformation } from './WorkerInformation'

interface Props {
  isOpen: boolean
  worker: {
    id: number
    name: string
    profilePicUrl?: string
    favorites: number
    rating: number
    numShiftsForCompany: number
    firstActive: string
    numFinishedShifts: number
    statusForCompany: StatusForCompanyEnum | null
    positionTemplateBlocks: {
      positionTemplateId: number
      blocked: boolean
    }[]
    rosters: {
      id: number
      name?: string
    }[]
  }
  shiftId?: number
  onClose: () => void
}

const getModalType = (worker: Props['worker']) => {
  const rating = worker.rating ?? 0
  const numShifts = worker.numFinishedShifts ?? 0

  if (worker.positionTemplateBlocks?.some((block) => block.blocked)) {
    return BlockModalType.Block
  }

  if (rating > 4 && numShifts >= 5) {
    return BlockModalType.WorkerInformation
  }

  if (numShifts <= 1) {
    return BlockModalType.NewWorker
  }

  return BlockModalType.Block
}

export function BlockModal(props: Props) {
  const { isOpen, worker, onClose } = props
  const [modalType, setModalType] = useState<BlockModalType>(() =>
    getModalType(worker)
  )

  const modalProps = useMemo(() => {
    return {
      isOpen,
      onClose,
      onNext: setModalType,
      worker,
    }
  }, [isOpen, onClose, setModalType, worker])

  if (modalType === BlockModalType.WorkerInformation) {
    return <WorkerInformation {...modalProps} />
  }

  if (modalType === BlockModalType.Feedback) {
    return <Feedback shiftId={props.shiftId} {...modalProps} />
  }

  if (modalType === BlockModalType.FillRate) {
    return <FillRate {...modalProps} />
  }

  if (modalType === BlockModalType.NewWorker) {
    return <NewWorker {...modalProps} />
  }

  if (modalType === BlockModalType.Block) {
    return <CompanyPositionTemplateBlock {...modalProps} />
  }

  return null
}
